
import { Link } from 'react-router-dom';

export default function PhilosophySection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <Link to="/about" className="block">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center cursor-pointer hover:opacity-90 transition-opacity">
            <div>
              <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-8 leading-tight">
                Collaboration over 
                <span className="block font-medium">self-promotion</span>
              </h2>
              
              <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
                <p>
                  I'm Esteban Ramirez — an award-winning photographer, graphic designer, and art director based in Los Angeles. For more than 13 years, I've worked at the intersection of photography, design, and brand storytelling, creating visuals and experiences that truly connect with audiences.
                </p>
                
                <p>
                  My approach is rooted in listening first. I step back to let each brand's identity, goals, and personality take the lead, focusing on what makes every project unique rather than imposing a signature style.
                </p>
                
                <p>
                  By combining strategic thinking with thoughtful visual execution, I turn complex challenges into clear, compelling narratives that resonate and deliver real impact.
                </p>
                
                <p>
                  Learn more about my process and background on my About page.
                </p>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/20e583c0c00c695ad3bb161b64e41a2b.jpeg"
                alt="Collaborative design process"
                className="w-full h-auto object-cover object-top rounded-sm"
              />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
